import { createAsyncThunk } from '@reduxjs/toolkit'
import { callErrorMsg } from 'helpers/errorMsg'
import { getOrderLocations } from 'features/Order/services/additionalSLA'
import {
  getThresholds,
  createThreshold,
  updateThreshold,
  deleteThreshold,
  CreateThresholdPayloadType,
  UpdateThresholdPayloadType,
} from 'features/Order/services/additionalSLABacklog'

export const SLICE_NAME = 'aslaBacklog'

export const fetchLocations = createAsyncThunk(
  `${SLICE_NAME}/fetchLocations`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await getOrderLocations()
      return response.data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const fetchThresholds = createAsyncThunk(
  `${SLICE_NAME}/fetchThresholds`,
  async (params: { location_id: number; factor_type: string }, { rejectWithValue }) => {
    try {
      const response = await getThresholds(params)
      return response.data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const submitCreateThreshold = createAsyncThunk(
  `${SLICE_NAME}/createThreshold`,
  async (payload: CreateThresholdPayloadType, { rejectWithValue }) => {
    try {
      const response = await createThreshold(payload)
      return response.data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const submitUpdateThreshold = createAsyncThunk(
  `${SLICE_NAME}/updateThreshold`,
  async ({ id, data }: { id: number; data: UpdateThresholdPayloadType }, { rejectWithValue }) => {
    try {
      const response = await updateThreshold(id, data)
      return response.data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const submitDeleteThreshold = createAsyncThunk(
  `${SLICE_NAME}/deleteThreshold`,
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await deleteThreshold(id)
      return response.data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)
